var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsStory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5322_55590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9852 24.8387C29.9713 24.8387 34.824 19.9861 34.824 14C34.824 8.01392 29.9713 3.16125 23.9852 3.16125C17.9992 3.16125 13.1465 8.01392 13.1465 14C13.1465 19.9861 17.9992 24.8387 23.9852 24.8387Z",
    fill: "#D6EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2805 13.2803L24.6137 13.2945V8.71952C24.6137 8.3209 24.2928 8 23.8942 8C23.4957 8 23.1747 8.3209 23.1747 8.71952L23.1888 13.2805H18.7195C18.3209 13.2805 18 13.6014 18 14C18 14.3985 18.3209 14.7194 18.7195 14.7194H23.1817V19.2805C23.1817 19.6788 23.5026 20 23.9012 20C24.2999 20 24.6208 19.6788 24.6208 19.2805V14.7195H29.2805C29.6791 14.7195 30 14.3984 30 14C30 13.6012 29.6755 13.2803 29.2805 13.2803Z",
    fill: "url(#paint0_linear_5322_55590)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1788 14C36.1788 14.4988 36.5832 14.9032 37.082 14.9032C37.5808 14.9032 37.9852 14.4988 37.9852 14C37.9852 6.28048 31.705 0 23.9852 0C23.4864 0 23.082 0.404414 23.082 0.903219C23.082 1.40202 23.4864 1.80644 23.9852 1.80644C30.7087 1.80644 36.1788 7.2765 36.1788 14ZM19.9183 2.4475C19.5903 2.4475 19.2748 2.26867 19.1158 1.95597L19.113 1.95066C19.0464 1.81947 19.0146 1.67985 19.0146 1.54204C19.0144 1.21282 19.1948 0.895467 19.5082 0.735835C19.9525 0.508936 20.4967 0.686452 20.723 1.13101C20.7898 1.26264 20.8217 1.40313 20.8217 1.5416C20.8217 1.87104 20.6423 2.18905 20.3291 2.34846C20.1972 2.41573 20.0565 2.4475 19.9183 2.4475ZM14.9528 5.41936C14.7142 5.41936 14.476 5.32541 14.2985 5.13909C13.9545 4.77788 13.9684 4.20612 14.3296 3.86208C14.8855 3.33265 15.4889 2.8455 16.123 2.41439C16.5356 2.13324 17.0975 2.24087 17.3778 2.65343C17.6583 3.066 17.5513 3.62769 17.1387 3.90818C16.5861 4.28394 16.0602 4.70843 15.5755 5.17021C15.4006 5.33668 15.1765 5.41936 14.9528 5.41936ZM10.9831 12.1741C11.0457 12.1874 11.1083 12.1938 11.1699 12.1938C11.5879 12.1938 11.9633 11.9018 12.0528 11.4762C12.3119 10.2442 12.7602 9.06402 13.3854 7.96808C13.6325 7.53479 13.4815 6.98327 13.0482 6.73608C12.6151 6.48933 12.0636 6.63972 11.8162 7.07323C11.098 8.33214 10.5829 9.68855 10.2852 11.1045C10.1824 11.5927 10.4949 12.0716 10.9831 12.1741ZM13.0613 22.129C12.7684 22.129 12.4813 21.987 12.3075 21.7248C10.9738 19.7126 10.182 17.375 10.0177 14.9645C9.98399 14.467 10.36 14.0359 10.8577 14.002C11.3565 13.9718 11.7863 14.3442 11.8202 14.8419C11.9631 16.9401 12.6522 18.9752 13.8133 20.7268C14.0889 21.1427 13.9751 21.703 13.5595 21.9786C13.4059 22.0805 13.2326 22.129 13.0613 22.129ZM15.2949 24.9769C17.7898 26.9545 20.7947 28 23.9851 28C24.4839 28 24.8883 27.5955 24.8884 27.0967C24.8884 26.5979 24.484 26.1935 23.9852 26.1935C21.2065 26.1935 18.5894 25.2833 16.4169 23.5613C16.0263 23.2514 15.4583 23.3171 15.148 23.7081C14.8382 24.0989 14.9039 24.6671 15.2949 24.9769ZM27.5973 27.4955C27.2044 27.4955 26.843 27.2373 26.7294 26.8408C26.5922 26.3612 26.8697 25.861 27.3491 25.7237C31.3575 24.5759 34.5607 21.3727 35.7085 17.3642C35.8461 16.8848 36.346 16.6076 36.8256 16.7445C37.305 16.8819 37.5824 17.382 37.4453 17.8616C36.1273 22.4642 32.4491 26.1424 27.8466 27.4604C27.7634 27.4843 27.6796 27.4955 27.5973 27.4955Z",
    fill: "url(#paint1_linear_5322_55590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5322_55590",
    x: 0.015625,
    y: 0,
    width: 47.9697,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5322_55590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5322_55590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5322_55590",
    x1: 24,
    y1: 20,
    x2: 24,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5322_55590",
    x1: 24.0004,
    y1: 28,
    x2: 24.0004,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsStory);
export default __webpack_public_path__ + "static/media/settings_story.b94f10dde700ab304edf9ed682b931e7.svg";
export { ForwardRef as ReactComponent };